import { render, staticRenderFns } from "./ManageDepositInfoTabV2.vue?vue&type=template&id=b1dfed60"
import script from "./ManageDepositInfoTabV2.vue?vue&type=script&lang=js"
export * from "./ManageDepositInfoTabV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1dfed60')) {
      api.createRecord('b1dfed60', component.options)
    } else {
      api.reload('b1dfed60', component.options)
    }
    module.hot.accept("./ManageDepositInfoTabV2.vue?vue&type=template&id=b1dfed60", function () {
      api.rerender('b1dfed60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/member/components/v2/tabs/ManageDepositInfoTabV2.vue"
export default component.exports